import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './components/App';

console.info('[deployment-verification] ui-release-check-2026-08-09');

ReactDOM.render(<Router><App /></Router>, document.getElementById('app'));
